import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = {
  key: 1,
  class: "warning"
}
const _hoisted_3 = {
  key: 2,
  class: "success"
}

import { computed, onMounted } from "vue";
import { useStatusStore } from "@/stores/root/status";


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusComponent',
  setup(__props) {

const statusStore = useStatusStore();
const status = computed(() => {
  return statusStore.status.stat;
});
const message = computed(() => {
  return statusStore.status.msg;
});
onMounted(() => {
  statusStore.clear();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (status.value > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (status.value == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(message.value), 1))
            : _createCommentVNode("", true),
          (status.value == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(message.value), 1))
            : _createCommentVNode("", true),
          (status.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(message.value), 1))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})